import React from "react";
import ReactDOM from "react-dom/client";
import "./js/App.scss";
import "./styles/tailwind.css";
import App from "./js/App";
import { BrowserRouter } from "react-router-dom";
import store from "./js/store/index";
import { Provider } from "react-redux";

/* Dev: CRA error overlay treats Axios "Network Error" as fatal when API is down from localhost. */
if (process.env.NODE_ENV === "development") {
  const suppress = (event) => {
    const r = event.reason;
    if (
      r &&
      (r.isAxiosError === true || r.name === "AxiosError") &&
      (r.message === "Network Error" || r.code === "ERR_NETWORK")
    ) {
      event.preventDefault();
    }
  };
  window.addEventListener("unhandledrejection", suppress);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
);
